import React from 'react';

export const useConnectionState = () => {
  const [isLoading, setIsLoadingState] = React.useState(false);
  const [isReconnecting, setIsReconnectingState] = React.useState(false);
  const [reconnectAttempts, setReconnectAttemptsState] = React.useState(0);
  const [isConnected, setIsConnectedState] = React.useState(false);

  const isLoadingRef = React.useRef(false);
  const isConnectedRef = React.useRef(false);
  const isReconnectingRef = React.useRef(false);
  const reconnectAttemptsRef = React.useRef(0);

  const setIsLoading = React.useCallback((val: boolean) => {
    isLoadingRef.current = val;
    setIsLoadingState(val);
  }, []);

  const setIsConnected = React.useCallback((val: boolean) => {
    isConnectedRef.current = val;
    setIsConnectedState(val);
  }, []);

  const setIsReconnecting = React.useCallback((val: boolean) => {
    isReconnectingRef.current = val;
    setIsReconnectingState(val);
  }, []);

  const setReconnectAttempts = React.useCallback((val: number | ((prev: number) => number)) => {
    setReconnectAttemptsState(prev => {
      const next = typeof val === 'function' ? val(prev) : val;
      reconnectAttemptsRef.current = next;
      return next;
    });
  }, []);

  return {
    isLoading,
    isConnected,
    isReconnecting,
    reconnectAttempts,
    isLoadingRef,
    isConnectedRef,
    isReconnectingRef,
    reconnectAttemptsRef,
    setIsLoading,
    setIsConnected,
    setIsReconnecting,
    setReconnectAttempts,
  };
};
